import React, { useContext, useEffect, useState } from 'react'
import { BodyText } from '@paypalcorp/pp-react'
import { ExternalLink } from '../../external-link'
import { NavLink } from 'react-router-dom'
import PropTypes, { shape } from 'prop-types'
import {
  ContainerAppProvider,
  RemoteModule,
} from '@paypalcorp/module-federation'
import { useApplicationContext } from '../../../../context/ApplicationContext'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { recordDynamicEvent } from '../../analytics/utils'

export const NavMenu = ({ menuList }) => {
  return (
    <ul className="dev_dash__logged_nav--items_container">
      {menuList?.map((item, idx) => {
        return <NavMenuItem item={item} key={idx} idx={idx} />
      })}
    </ul>
  )
}

const NavMenuItem = ({ item, idx }) => {
  const worldReady = useContext(WorldReadyContext)
  const {
    csrf,
    profileSwitcherUrl,
    profileSwitcherUuid,
    showSwitchProfile,
    showDeveloperInvite,
  } = useApplicationContext()
  const [showProfileSwitch, setShowProfileSwitch] = useState(false)
  const [hasSubMenu, setHasSubMenu] = useState(false)
  const openSheet = () => {
    recordDynamicEvent(`switch_profile,click,clicked_switch_profile_menu`)
    setShowProfileSwitch(true)
  }
  const closeSwitchProfile = () => {
    recordDynamicEvent(
      `switch_profile,click,closed_switch_profile_menu_closeButton`,
    )
    setShowProfileSwitch(false)
  }
  const fptiData = {
    pgrp: 'nav-menu:dashboard',
    page: 'profile-switcher:dashboard',
  }

  const remoteConfig = {
    name: 'profile-switcher',
    url: profileSwitcherUrl,
    fallback: profileSwitcherUrl,
    module: './ProfileSwitcher',
    scope: 'profileSwitcher',
  }

  useEffect(() => {
    setHasSubMenu(item.menuItems?.length)
  }, [])

  const addFPTI = (menuItem, subItem) => {
    const excludeItem = ['Braintree GraphQL API', 'Demo portal', 'API status'];
    if (!excludeItem.includes(subItem.title)) {
      const mergedBothTitle = subItem.title ? menuItem.title + '_' + subItem.title : menuItem.title;
      const event_name = mergedBothTitle
        .toLowerCase()
        .replace(/[&/]/g, '')
        .replace(/\s+/g, '_')
      recordDynamicEvent(
        `developer_dashboard,click,developer_dashboard_menu_${event_name}`,
      )
    }
  }

  return (
    <>
      <li
        className={`dropdown`}
        onKeyDown={(e) => {
          if (hasSubMenu && e.key === 'Enter') {
            const itemList = document.getElementById(item.title)
            itemList.classList.toggle('showMenu')
          }
        }}
        key={`nav-list-${idx}`}
      >
        <BodyText
          className={`menu-button ${
            hasSubMenu ? 'aria-haspopup="true" aria-expanded="false"' : ''
          }`}
          as={ExternalLink}
          onClick={() => addFPTI(item, '')}
          href={item.path}
          tabIndex="0"
        >
          {item.title}
        </BodyText>
        {hasSubMenu && (
          <ul id={item.title} className={'dropdown-content'}>
            {item.menuItems.map((subItem, subIdx) => {
              if (subItem.title === 'Switch Profiles') {
                return showSwitchProfile && showDeveloperInvite ? (
                  <li key={subIdx} onClick={openSheet}>
                    <BodyText
                      as={NavLink}
                      to={subItem.path}
                      target={subItem.target || '_self'}
                      key={subIdx}
                    >
                      {subItem.title}
                    </BodyText>
                  </li>
                ) : null
              }
              const linkType = subItem.path.startsWith('https://') ? (
                <BodyText
                  as={ExternalLink}
                  href={subItem.path}
                  target={subItem.target || '_blank'}
                  key={subIdx}
                  onClick={() => addFPTI(item, subItem)}
                >
                  {subItem.title}
                </BodyText>
              ) : (
                <BodyText
                  as={NavLink}
                  to={subItem.path}
                  target={subItem.target || '_self'}
                  key={subIdx}
                >
                  {subItem.title}
                </BodyText>
              )

              return <li key={subIdx}>{linkType}</li>
            })}
          </ul>
        )}
      </li>
      {showProfileSwitch && (
        <ContainerAppProvider modules={{ 'profile-switcher': remoteConfig }}>
          <RemoteModule
            config={remoteConfig}
            disableHostOverride={true}
            csrf={csrf}
            showSwitcher={showProfileSwitch}
            handleClose={closeSwitchProfile}
            locale={worldReady}
            isWidget={true}
            fptiData={fptiData}
            fnSessionId={profileSwitcherUuid}
          />
        </ContainerAppProvider>
      )}
    </>
  )
}
export default NavMenu

NavMenu.propTypes = {
  menuList: PropTypes.array.isRequired,
}

NavMenuItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    path: PropTypes.string,
    menuItems: PropTypes.arrayOf(
      shape({
        title: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
      }),
    ),
  }),
  idx: PropTypes.number,
}
